/**
 * 需求市场路由
 */
const routerReward = [
  {
    path: '/reward',
    name: 'Reward',
    meta: {
      title: '需求集市',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: true,
      isJH: true,
    },
    component: () => import('@/pages/module-reward/index.vue'),
  },
  {
    path: '/reward-detail/:id',
    name: 'RewardDetail',
    meta: {
      title: '需求集市详情',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-reward/RewardDetail.vue'),
  },
];

export default routerReward;
